/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StringTTLOCriteriaOutput
 */
export interface StringTTLOCriteriaOutput {
    /**
     * 
     * @type {boolean}
     * @memberof StringTTLOCriteriaOutput
     */
    exclude?: boolean;
    /**
     * 
     * @type {string}
     * @memberof StringTTLOCriteriaOutput
     */
    value?: string | null;
}

export function StringTTLOCriteriaOutputFromJSON(json: any): StringTTLOCriteriaOutput {
    return StringTTLOCriteriaOutputFromJSONTyped(json, false);
}

export function StringTTLOCriteriaOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): StringTTLOCriteriaOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function StringTTLOCriteriaOutputToJSON(value?: StringTTLOCriteriaOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'exclude': value.exclude,
        'value': value.value,
    };
}


